import { Grid, Typography, Card, CardContent, Box, Button } from '@mui/material';
import { motion } from 'framer-motion';

const InvestmentShowcase = () => {
  return (
    <Box sx={{ py: 8, padding: 10}}>
      <Typography variant="h3" component="h2" align="center" sx={{ mb: 6, fontWeight: 'bold' }}>
        Featured Investment: Revelstoke Capital
      </Typography>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Card sx={{ boxShadow: 3 }}>
              <CardContent sx={{ p: 0 }}>
                <Box
                  component="img"
                  src="/revelstoke.jpg"
                  alt="Revelstoke Capital"
                  sx={{ width: '100%', height: 'auto' }}
                />
              </CardContent>
            </Card>
          </motion.div>
        </Grid>
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
              Denver-based middle-market private equity firm specializing in healthcare services
            </Typography>
            <Typography variant="body1" paragraph sx={{ mb: 2 }}>
              Revelstoke manages $2.8 billion in fee-paying AUM and has achieved a 3.1X gross MOIC across realized investments.
            </Typography>
            <Typography variant="body1" paragraph sx={{ mb: 2 }}>
              The firm has experienced over 100% fund-over-fund growth in its last two flagship funds, demonstrating strong scalability.
            </Typography>
            <Typography variant="body1" paragraph sx={{ mb: 3 }}>
              Revelstoke's exclusive focus on healthcare services provides portfolio diversification and exposure to a $4 trillion market.
            </Typography>
            <Button variant="outlined" size="large">
              Learn More About Revelstoke
            </Button>
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvestmentShowcase;
